import React from "react";
import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

// components
import FourCards from "../../Cards/FourCards";

// styles
import * as styles from "./TransformCard.module.css";

// images
import reverseIcon from "../../../images/doctor/reverse-icn.png";
import medIcon from "../../../images/doctor/med-icn.png";
import aiIcon from "../../../images/doctor/ai-icn.png";
import patientIcon from "../../../images/doctor/patient-icn.png";

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
};

const defaultProps = {
  title: "Transform Chronic Care with AI-Driven Precision Care",
  description:
    "Twin Health helps doctors move beyond symptom management with AI-powered metabolic insights that support remission, safely reduce medication, and strengthen long-term patient outcomes.",
};

const TransformCard = ({ title, description }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const cardsData = [
    {
      icon: reverseIcon,
      title: "Reverse or manage Type 2 Diabetes, Obesity, PMOS, BP & more",
      iconAlt: "Reverse or manage chronic conditions",
    },
    {
      icon: medIcon,
      title: "Medication reduction under medical supervision",
      iconAlt: "Medication reduction",
    },
    {
      icon: aiIcon,
      title: "Improve patient compliance with AI-driven daily guidance",
      iconAlt: "AI-driven patient guidance",
    },
    {
      icon: patientIcon,
      title: "Build a healthier, more satisfied patient community",
      iconAlt: "Satisfied patient community",
    },
  ];

  return (
    <section className={styles.transformCardWrapper}>
      <div
        ref={ref}
        className={`container scroll_animate ${inView && "inview"}`}
      >
        {/* Header Section */}
        <div className={styles.headerSection}>
          <h2 className={styles.title}>{title}</h2>
          <p className={styles.description}>{description}</p>
        </div>

        {/* Cards Section */}
        <div className={styles.cardsSection}>
          <FourCards cards={cardsData} variant="doctor" />
        </div>
      </div>
    </section>
  );
};

TransformCard.propTypes = propTypes;
TransformCard.defaultProps = defaultProps;

export default TransformCard;
